@if(yourMindLogIsActive()){
  <div class="sequence-container">
    <span class="last-30">{{ 'historical.last-30' | translate }}</span>
    @if(loadingLogs()){
      <app-loading></app-loading>
    }@else {
      <div class="mood-container">
          @for (item of listCompleted(); track $index) {
            @if (item) {
              <div class="mood" [class]="getMoodColor(item.mood)">
                <img [src]="getMood(item.mood).image" [alt]="getMood(item.mood).label" class="mood-icon">
              </div>
            }@else {
              <div class="mood"></div>
            }
          }
        </div> 
    }
  </div>
}@else if(sharedWithYouIsActive()){
  <app-users-sharing-logs
    [psychologist]="psychologist()"
    [filterBy]="filterBy()"
    (userSelected)="filterByUser($event)"
  >
  </app-users-sharing-logs>  
  <div class="sequence-shared-container">
    <span class="last-30">{{ 'historical.last-30' | translate }}</span>
    @if(loadingSharedLogs()){
      <app-loading></app-loading>
    }@else {
      @if(listShared()?.length !== 0){
        <div class="mood-container">
          @for (item of listSharedCompleted(); track $index) {
            @if (item) {
              <div class="mood" [class]="getMoodColor(item.logs.mood)">
                <img [src]="getMood(item.logs.mood).image" [alt]="getMood(item.logs.mood).label" class="mood-icon">
              </div>
            }@else {
              <div class="mood"></div>
            }
          }
        </div> 
      }@else if(listShared()?.length === 0){
        <div class="no-user-selected">
          <img src="/imgs/thinking.png">
          <div>{{ 'historical.select_name' | translate }}</div>
        </div>
      }
    }    
  </div>
}